import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { ICityMastDropdown, IClientCompanyDropdown, ICountryMastDropdown, IStateMastDropdown, IUniversityDropdown, IVisaDropdown } from "../../models/IDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { EmptySubmission } from "../../components/requirement/EmptySubmission";
import { NoticePeriod, Experience, Submission_Type, Tax_Term } from "../../models/FDropdown";
import { IConsultantMast, IConsultantRef, TaxTerm } from "../../models/ConsultantMast";
import { AutoComplete } from "primereact/autocomplete";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { IClientContactPerson } from "../../models/ClientContactPerson";
import { IRecruiterRequirements } from "../../models/RecruiterRequirements";
import { FileUpload, FileUploadHandlerParam } from 'primereact/fileupload';
import { Req } from "../../shared/Req";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { JVInputMask } from "../../shared/JVInputMask";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { ILogin } from "../../models/Login";
import { EmployerDetails } from "../../components/requirement/recruiter/EmployerDetails";
import { IRequirementMast } from "../../models/RequirementMast";
import { IConsSubmission, SubmissionsTable } from "../requirement/recruiter/SubmissionsTable";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVRadioBtn } from "../../shared/JVRadioBtn";

interface Iprops {
    singleData: IRecruiterRequirements,
    body: any,
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

const emailSchema = yup.object().shape({
    email: yup.string().required().email()
});
const idSchema = yup.object().shape({
    id: yup.number().required().min(1)
});

const schema = yup.object({
    consultant_Name: yup.string().required(),
    consultant_Email_ID: yup.string().required().email(),
    consultant_Home_No: yup.string().required(),
    consultant_Job_Title: yup.string().required(),
    visa_Status: yup.number().min(1).required(),
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*").required("State is required*"),
        state_Name: yup.string().required()
    }),
    city: yup.object().shape({
        city_ID: yup.number().min(1, "City is required*").required("City is required*"),
        city_Name: yup.string().required()
    }),
    total_Experience: yup.number().min(1).required(),
    availability: yup.string().required(),
    faceToFaceInterview: yup.boolean().required(),
    hourly_Rate: yup.number().required(),
    tax_Term: yup.number().required(),
    payment_Term: yup.number().when('tax_Term', val => {
        return (val === TaxTerm.Tax_1099_All_Inclusive || val === TaxTerm.Tax_1099_With_Benefits || val === TaxTerm.W2_All_Inclusive || val === TaxTerm.W2_With_Benefits) ?
            yup.number().min(1).required("Payment Term is Required").nullable() :
            yup.number().nullable();
    }),
    contact_Person_EmailID: yup.string().when('tax_Term', val => {
        return (val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive) ?
            yup.string().email().required() :
            yup.string();
    }),
    company: yup.object().when('tax_Term', val => {
        return (val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive) ?
            yup.object().shape({
                vendor_Company_ID: yup.number().min(1, "Employer Company is required*").required("Employer Company is required*"),
                vendor_Company_Name: yup.string().required()
            }) :
            yup.object().shape({
                vendor_Company_ID: yup.number(),
                vendor_Company_Name: yup.string()
            });
    }),
    contact_Person_Name: yup.string().when('tax_Term', val => {
        return (val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive) ?
            yup.string().required() :
            yup.string();
    }),
    phone_No: yup.string().when('tax_Term', val => {
        return (val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive) ?
            yup.string().required() :
            yup.string();
    }),

    degree: yup.string(),
    university_Name: yup.string(),
    passoutYear: yup.string(),
    country: yup.object().shape({
        country_ID: yup.number(),
        country_Name: yup.string()
    }),
    ssn: yup.string(),
    linkedin: yup.string().url().nullable(),
    submissionType: yup.number().nullable(),
    annual_Salary: yup.string(),

    r1_Ref_ID: yup.number().nullable(),
    r1_Company_Name: yup.string().nullable(),
    r1_POC_Name: yup.string().nullable(),
    r1_Phone: yup.string().nullable(),
    r1_Email: yup.string().email("invalid email").nullable(),

    r2_Ref_ID: yup.number().nullable(),
    r2_Company_Name: yup.string().nullable(),
    r2_POC_Name: yup.string().nullable(),
    r2_Phone: yup.string().nullable(),
    r2_Email: yup.string().email("invalid email").nullable(),

    r3_Ref_ID: yup.number().nullable(),
    r3_Company_Name: yup.string().nullable(),
    r3_POC_Name: yup.string().nullable(),
    r3_Phone: yup.string().nullable(),
    r3_Email: yup.string().email("invalid email").nullable()
});

export const QuickSubmission = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [refCount, setRefCount] = useState(1);
    const [data, setData] = useState<IRequirementMast>();

    const PaymentTerm = [
        { name: "By Weekly", value: 1 },
        { name: "Net Fifteen", value: 2 },
        { name: "Net Thirty", value: 3 },
        { name: "Net Forty Five", value: 4 },
        { name: "Net Sixty", value: 5 },
    ]

    useEffect(() => {
        if (props.singleData.req_ID) loadData();
    }, [props.singleData.req_ID]);

    const loadData = async () => {
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setData(data);
        }
    }

    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [countries, setCountries] = useState<Array<ICountryMastDropdown>>();
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [universities, setUniversities] = useState<Array<IUniversityDropdown>>();
    const [university, setUniversity] = useState<IUniversityDropdown | undefined | string>(undefined);
    const [additionInfo, setAdditionInfo] = useState("");
    const [disableEmployeeDetails, setDisableEmployeeDetails] = useState(false);
    const [disablePaymentsTerm, setDisablePaymentsTerm] = useState(true);
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);
    const [disableConsultant, setDisableConsultant] = useState(true);

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<IConsultantMast>({
        resolver: yupResolver(schema),
        defaultValues: EmptySubmission,
        shouldFocusError: false
    });

    const [subTable, setSubTable] = useState({ data: [], open: false } as { data: Array<IConsSubmission>, open: boolean });
    const [employerDetails, setEmployerDetails] = useState({ data: [], open: false, consultant_ID: 0 } as { data: Array<any>, open: boolean, consultant_ID: number | undefined });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "tax_Term") {
                if (value.tax_Term === TaxTerm.C2C_With_Benefits || value.tax_Term === TaxTerm.C2C_All_Inclusive) {
                    setDisableEmployeeDetails(false);
                } else {
                    setDisableEmployeeDetails(true);
                }
            }
            if (name === "tax_Term") {
                if (value.tax_Term === TaxTerm.Tax_1099_All_Inclusive || value.tax_Term === TaxTerm.Tax_1099_With_Benefits || value.tax_Term === TaxTerm.W2_All_Inclusive || value.tax_Term === null || value.tax_Term === TaxTerm.W2_With_Benefits) {
                    setDisablePaymentsTerm(false)
                } else {
                    setDisablePaymentsTerm(true)
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const hideSubTable = () => {
        setSubTable({ data: subTable.data, open: false });
        setEmployerDetails({ data: [], open: false, consultant_ID: 0 });
    };

    useEffect(() => {
        if (university) {
            let un: string | undefined = undefined;
            if (typeof (university) === 'string') {
                un = university;
            } else {
                un = university?.university_Name;
            }
            setValue("university_Name", un);
        } else {
            setValue("university_Name", undefined);
        }
    }, [university]);

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadCountries = async (filter: string | null) => {
        const response = await Fetch("Dropdown/countries", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICountryMastDropdown> = await response.json();
            setCountries(data);
        }
    }
    const completeMethodCountries = (event: { query: string }) => {
        loadCountries(event.query);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies_emp_details", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }

    const loadUniversities = async (filter: string | null) => {
        const response = await Fetch("Dropdown/universities", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IUniversityDropdown> = await response.json();
            setUniversities(prev => prev = data);
        }
    }
    const completeMethodUniversities = (event: { query: string }) => {
        loadUniversities(event.query);
    }

    useEffect(() => {
        loadVisa();
    }, []);

    const fillSubVendor = async () => {
        setLoading(true);
        if (control._formValues.contact_Person_EmailID === "") return;
        const email = control._formValues.contact_Person_EmailID;
        if (!(email?.includes("gmail") || email?.includes("outlook")
            || email?.includes("protonmail") || email?.includes("aol")
            || email?.includes("yahoo") || email?.includes("hotmail")
            || email?.includes("rediff"))) {
            const valid = await emailSchema.isValid({
                email: control._formValues.contact_Person_EmailID,
            });
            if (valid) {
                const response = await Fetch("Sub_Vendor_Contact_Person_Mast/email", "GET", null, `email=${control._formValues.contact_Person_EmailID}`, props.toast);
                if (response) {
                    const data: Array<IClientContactPerson> = await response.json();

                    if (data.length > 0) {
                        setValue("contact_Person_EmailID", data[0].contact_Person_EmailID);
                        setValue("contact_Person_Name", data[0].contact_Person_Name);
                        setValue("phone_No", data[0].phone_No);
                        setValue("vendor_Company_ID", data[0].vendor_Company_ID);
                        setValue("company", { vendor_Company_ID: data[0].vendor_Company_ID, vendor_Company_Name: data[0].vendor_Company_Name });
                    } else {
                        setValue("contact_Person_Name", '');
                        setValue("phone_No", undefined);
                        setValue("vendor_Company_ID", undefined);
                        setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
                        props.toast.current.show({ severity: 'info', content: "No Employer Found resistered with this Email-ID" });
                    }
                }
            }
            else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Employer Email-ID" });
        } else {
            setValue("contact_Person_Name", '');
            setValue("phone_No", undefined);
            setValue("vendor_Company_ID", undefined);
            setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
            props.toast.current.show({ severity: 'error', content: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
        }
        setLoading(false);
    }

    const saveToDB = async (body: IConsultantMast) => {
        setLoading(true);
        if (body.dobdd === undefined) body.dobdd = "";
        if (body.dobmm === undefined) body.dobmm = "";
        if (body.dobyyyy === undefined) body.dobyyyy = "";

        const consultant_Data = {
            consultant_ID: body.consultant_ID,
            consultant_Name: body.consultant_Name,
            consultant_Email_ID: body.consultant_Email_ID?.trim().toLowerCase(),
            consultant_Home_No: body.consultant_Home_No,
            consultant_Job_Title: body.consultant_Job_Title,
            visa_Status: body.visa_Status,
            consultant_State: body.state?.state_Name,
            consultant_City: body.city?.city_ID,
            total_Experience: body.total_Experience,
            availability: body.availability,
            hourly_Rate: body.hourly_Rate,
            dob: body.dobmm + "-" + body.dobdd + "-" + body.dobyyyy,
            ssn: body.ssn,
            linkedin: body.linkedin,
            consultant_Country: body.country?.country_ID,
            annual_Salary: body.annual_Salary ? body.annual_Salary : undefined,
            university_Name: body.university_Name,
            degree: body.degree,
            passoutYear: body.passoutYear,
        };

        const consultant_Submittal_Logs: IConsultantMast = {
            requirement_ID: props.singleData.req_ID,
            faceToFaceInterview: body.faceToFaceInterview,
            tax_Term: body.tax_Term,
            payment_Term: body.payment_Term,
            submissionType: body.submissionType,
            buying_Rate: body.hourly_Rate,
            addition_Info: additionInfo,
        };

        const sub_Vendor_Contact_Person_Mast: IConsultantMast = {
            contact_Person_EmailID: body.contact_Person_EmailID,
            contact_Person_Name: body.contact_Person_Name,
            phone_No: body.phone_No,
            vendor_Company_ID: body.company?.vendor_Company_ID,
        };

        const consultant_References_List: Array<IConsultantRef> = [];
        for (let i = 0; i < refCount; i++) {
            if (i === 0) {
                const element: IConsultantRef = {
                    ref_ID: body.r1_Ref_ID ? body.r1_Ref_ID : undefined,
                    consultant_ID: body.consultant_ID,
                    company_Name: body.r1_Company_Name,
                    poC_Name: body.r1_POC_Name,
                    phone: body.r1_Phone,
                    email: body.r1_Email,
                };
                consultant_References_List.push(element);
            } else if (i === 1) {
                const element: IConsultantRef = {
                    ref_ID: body.r2_Ref_ID ? body.r2_Ref_ID : undefined,
                    consultant_ID: body.consultant_ID,
                    company_Name: body.r2_Company_Name,
                    poC_Name: body.r2_POC_Name,
                    phone: body.r2_Phone,
                    email: body.r2_Email,
                };
                consultant_References_List.push(element);
            } else if (i === 2) {
                const element: IConsultantRef = {
                    ref_ID: body.r3_Ref_ID ? body.r3_Ref_ID : undefined,
                    consultant_ID: body.consultant_ID,
                    company_Name: body.r3_Company_Name,
                    poC_Name: body.r3_POC_Name,
                    phone: body.r3_Phone,
                    email: body.r3_Email,
                };
                consultant_References_List.push(element);
            }
        }

        const formData = new FormData();
        formData.append("consultantData", JSON.stringify(consultant_Data));
        formData.append("subVendorContact", JSON.stringify(sub_Vendor_Contact_Person_Mast));
        formData.append("submissionData", JSON.stringify(consultant_Submittal_Logs));
        formData.append("references", JSON.stringify(consultant_References_List));
        formData.append("resume", resumeFile);
        const params = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
            },
            body: formData,
        };
        const response = await fetch(
            `${baseUrl}Consultant_Mast/submission/${props.singleData.req_ID}?quickSub=true`,
            params,
        );

        if (!response.ok) {
            const message = await response.text();
            props.toast.current.show({ severity: 'error', detail: message, life: 3000 });

        } else {
            const data = await response.json();
            props.toast.current.show({ severity: 'success', content: data.message });
            onHide();
        }
        setLoading(false);
    }

    function onSubmit(data: IConsultantMast) {
        const email = data.contact_Person_EmailID;

        if (disableEmployeeDetails) {
            saveToDB(data);
        } else {
            if (!(email?.includes("gmail") || email?.includes("outlook")
                || email?.includes("protonmail") || email?.includes("aol")
                || email?.includes("yahoo") || email?.includes("hotmail")
                || email?.includes("rediff"))) {
                saveToDB(data);
            } else {
                setValue("contact_Person_Name", '');
                setValue("phone_No", undefined);
                setValue("vendor_Company_ID", undefined);
                setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
                props.toast.current.show({ severity: 'error', content: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
            }
        }
    }

    const onHide = () => {
        reset(EmptySubmission);
        setDisablePaymentsTerm(true);
        setDisableConsultant(true);
        setRefCount(1);
        setSubTable({ data: [], open: false });
        setAdditionInfo("");
        setResumeFile(null);
        props.hideDialog();
    }

    const dFooter = () => {
        return (<div className="col-12 md:col-12 flex gap-4 justify-content-end">
            <Button loading={loading} form="submissionForm" label="SAVE" type="submit" style={{ width: '100px' }} ></Button>
            <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLEAR" onClick={() => { reset(EmptySubmission); setUniversity(undefined); setRefCount(1); setSubTable({ data: [], open: false }); }} type="button"></Button>
        </div>);
    }

    const resumeUpload = (event: FileUploadHandlerParam) => {
        const file = event.files[0];
        if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            if (file.size > 1024 * 1024 * 2) {
                props.toast.current.show({ severity: "error", content: "DOCX File should be less than 2 MB." });
                event.options.clear();
                setResumeFile(null);
            } else {
                setResumeFile(file);
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: "error", content: "Please Choose A DOCX File." });
            event.options.clear();
            setResumeFile(null);
        }
    };

    const handleEmployerSelect = (employer: any) => {
        setValue('contact_Person_EmailID', employer.contact_Person_EmailID);
        setValue('company', { vendor_Company_ID: employer.vendor_Company_ID, vendor_Company_Name: employer.company });
        setValue('contact_Person_Name', employer.contact_Person_Name);
        setValue('phone_No', employer.phone_No);
    };

    useEffect(() => {
        if (props.open) {
            let bodyData: any = props.body;
            bodyData.state = {
                state_ID: props.body.state_ID,
                state_Name: props.body.state_Name
            };
            bodyData.city = {
                city_ID: props.body.city_ID,
                city_Name: props.body.city_Name
            };
            bodyData.visa_Status = Number(props.body.visa_Status);

            if (props.body.contact_Person_EmailID !== undefined || props.body.contact_Person_EmailID !== null || props.body.contact_Person_EmailID !== "") bodyData.contact_Person_EmailID = props.body.contact_Person_EmailID;
            else delete bodyData.contact_Person_EmailID;

            if (props.body.contact_Person_Name !== undefined || props.body.contact_Person_Name !== null || props.body.contact_Person_Name !== "") bodyData.contact_Person_Name = props.body.contact_Person_Name;
            else delete bodyData.contact_Person_Name;

            if (props.body.phone_No === undefined || props.body.phone_No === null || props.body.phone_No === "") delete bodyData.phone_No;
            else bodyData.phone_No = props.body.phone_No;

            if (props.body.tax_Term === "C2C with Benefits" || props.body.tax_Term === "C2C All Inclusive") {
                setDisableEmployeeDetails(prev => prev = false);
                bodyData.contact_Person_Name = props.body.contact_Person_Name;
                bodyData.company = {
                    vendor_Company_ID: props.body.vendor_Company_ID,
                    vendor_Company_Name: props.body.vendor_Company_Name
                };
                bodyData.phone_No = props.body.phone_No;
            } else {
                setDisableEmployeeDetails(prev => prev = true);
                delete bodyData.contact_Person_EmailID;
                delete bodyData.company;
                delete bodyData.contact_Person_Name;
                delete bodyData.phone_No;
            };

            if (props.body.degree === undefined || props.body.degree === null || props.body.degree === "") delete bodyData.degree;

            if (props.body.university_Name === undefined || props.body.university_Name === null || props.body.university_Name === "") delete bodyData.university_Name;
            else bodyData.university_Name = props.body.university_Name;

            if (props.body.passoutYear === undefined || props.body.passoutYear === null || props.body.passoutYear === "") delete bodyData.passoutYear;
            else bodyData.passoutYear = props.body.passoutYear;

            if (props.body.country_ID !== undefined && props.body.country_ID !== null && props.body.country_ID !== 0) {
                bodyData.country = {
                    country_ID: props.body.country_ID,
                    country_Name: props.body.country_Name
                };
            } else delete bodyData.country;

            if (props.body.dob !== undefined && props.body.dob !== null && props.body.dob !== "") {
                bodyData.dobmm = props.body.dob ? `${new Date(props.body.dob || "").getMonth() < 10 ? '0' + `${new Date(props.body.dob || "").getMonth()}` : new Date(props.body.dob || "").getMonth()}` : null;
                bodyData.dobdd = props.body.dob ? `${new Date(props.body.dob || "").getDay() < 10 ? '0' + `${new Date(props.body.dob || "").getDay()}` : new Date(props.body.dob || "").getDay()}` : null;
                bodyData.dobyyyy = props.body.dob ? `${new Date(props.body.dob || "").getFullYear()}` : null;
            } else {
                delete bodyData.dobmm;
                delete bodyData.dobdd;
                delete bodyData.dobyyyy;
            }

            if (props.body.ssn !== undefined && props.body.ssn !== null && props.body.ssn !== 0) bodyData.ssn = props.body.ssn;
            else delete bodyData.ssn;

            if (props.body.linkedin !== undefined && props.body.linkedin !== null && props.body.linkedin !== "") bodyData.linkedin = props.body.linkedin;
            else delete bodyData.linkedin;

            if (props.body.submissionType !== undefined && props.body.submissionType !== null && props.body.submissionType !== 0) bodyData.submissionType = props.body.submissionType;
            else delete bodyData.submissionType;

            bodyData.annual_Salary = props.body.annual_Salary || 0;

            if (props.body.university_Name !== null && props.body.university_Name !== undefined && props.body.university_Name.trim() !== "") {
                loadUniversities(props.body.university_Name);
            }
            reset(bodyData);
        }
    }, [props.open]);

    useEffect(() => {
        if (props.open && props.body.university_Name !== undefined && props.body.university_Name !== null && props.body.university_Name.trim() !== "") {
            setUniversity((universities || []).filter(e => e.university_Name === props.body.university_Name)[0]);
        }
    }, [props.open, universities]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Consultant" footer={dFooter} className="p-fluid" maximizable onHide={onHide}>
            {data && <Req req={data} />}
            <form id="submissionForm" onSubmit={handleSubmit(onSubmit)}>
                <div style={{ margin: '10px 0', width: '100%' }}></div>

                <Accordion multiple activeIndex={[0, 1]}>
                    <AccordionTab header="Consultant Required Details:">
                        <div className="p-fluid formgrid grid">
                            <JVInput required disabled={(!_roles.includes(1)) && disableConsultant} placeholder="Consultant Name" column={3} control={control} name="consultant_Name" error={errors.consultant_Name?.message} />
                            <JVInput required disabled placeholder="Email" column={3} control={control} name="consultant_Email_ID" error={errors.consultant_Email_ID?.message} />
                            <JVInputMask required mask="(999) 999-9999" column={3} placeholder="Phone" control={control} name="consultant_Home_No" error={errors.consultant_Home_No?.message} />
                            <JVInput required placeholder="Job Title" column={3} control={control} name="consultant_Job_Title" error={errors.consultant_Job_Title?.message} />

                            <JVDropdown required column={3} control={control} name="visa_Status" error={errors.visa_Status?.message} options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="--Select Visa--" />
                            <JVDropdownInput required column={3} completeMethod={completeMethodStates} control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                            <JVDropdownInput required column={3} completeMethod={completeMethodCities} control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
                            <JVDropdown required column={3} control={control} name="total_Experience" error={errors.total_Experience?.message} options={Experience} optionLabel="name" optionValue="name" placeholder="--Select Total Exp--" />

                            <JVDropdown required column={3} control={control} name="availability" error={errors.availability?.message} options={NoticePeriod} optionLabel="name" optionValue="value" placeholder="--Select NoticePeriod--" />
                            <JVInput required placeholder="Buying Rate" type={"number"} column={3} control={control} name="hourly_Rate" error={errors.hourly_Rate?.message} />
                            <JVDropdown required column={3} control={control} name="tax_Term" error={errors.tax_Term?.message} options={Tax_Term} optionLabel="name" optionValue="id" placeholder="--Select TaxTerm--" />
                            {!disablePaymentsTerm && <JVDropdown required column={3} disabled={disablePaymentsTerm} control={control} name="payment_Term" error={errors.payment_Term?.message} options={PaymentTerm} optionLabel="name" optionValue="value" placeholder="--Select PaymentTerm--" />}
                            <JVRadioBtn inline label="F2F Interview" required data={[{ "label": "Yes", "value": true }, { "label": "No", "value": false }]} column={3} control={control} name="faceToFaceInterview" error={errors.faceToFaceInterview?.message} />
                        </div>
                    </AccordionTab>
                    {!disableEmployeeDetails && <AccordionTab header="Employer Details:">
                        <Button icon="pi pi-search" type="button" className="p-button-rounded p-button-success mb-2" aria-label="see details" onClick={() => { setEmployerDetails({ data: employerDetails.data, open: true, consultant_ID: employerDetails.consultant_ID }); }} />
                        <div className="p-fluid formgrid grid">
                            <JVInput required disabled={disableEmployeeDetails} onBlur={fillSubVendor} placeholder="Employer Email" column={4} control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />
                            <JVDropdownInput required disabled={disableEmployeeDetails} column={4} completeMethod={completeMethodEC} control={control} name="company" error={errors.company?.vendor_Company_ID?.message} options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Employer Company" />
                            <JVInput required disabled={disableEmployeeDetails} placeholder="Contact Name" column={4} control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                            <JVInputMask required disabled={disableEmployeeDetails} mask="(999) 999-9999" column={4} placeholder="Employer Phone" control={control} name="phone_No" error={errors.phone_No?.message} />
                        </div>
                    </AccordionTab>}
                    <AccordionTab header="Education & Other Details:">
                        <div className="p-fluid formgrid grid">
                            <JVInput placeholder="Degree" column={3} control={control} name="degree" error={errors.degree?.message} />
                            <div className="field col-12 md:col-4">
                                <div className="p-inputgroup">
                                    <AutoComplete suggestions={universities}
                                        completeMethod={completeMethodUniversities} field='university_Name' value={university}
                                        placeholder="Search/Type University" onChange={(e) => setUniversity(e.value)} />
                                </div>
                                <small className="p-error" >{errors.university_Name?.message}</small>
                            </div>
                            <JVInput placeholder="Passing Year" column={3} control={control} name="passoutYear" error={errors.passoutYear?.message} />
                            <JVDropdownInput column={3} completeMethod={completeMethodCountries} control={control} name="country" error={errors.country?.country_ID?.message} options={countries} optionLabel="country_Name" placeholder="Search Country" />

                            <div className="field col-12 md:col-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <JVInputMask mask="99" column={3} placeholder="MM" control={control} name="dobmm" />
                                <JVInputMask mask="99" column={3} placeholder="DD" control={control} name="dobdd" />
                                <JVInputMask mask="9999" column={3} placeholder="YYYY" control={control} name="dobyyyy" />
                            </div>

                            <JVInput placeholder="SSN" column={3} type={"number"} control={control} name="ssn" error={errors.ssn?.message} />
                            <JVInput placeholder="Linkedin" column={3} control={control} name="linkedin" error={errors.linkedin?.message} />

                            <JVDropdown column={3} control={control} name="submissionType" error={errors.submissionType?.message} options={Submission_Type} optionLabel="name" optionValue="id" placeholder="--Select JobType--" />
                            <JVInput placeholder="Salary" type={"number"} column={3} control={control} name="annual_Salary" error={errors.annual_Salary?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="References:">
                        <div className="p-fluid formgrid grid">
                            <JVInput placeholder="Company Name" column={4} control={control} name="r1_Company_Name" />
                            <JVInput placeholder="POC Name" column={4} control={control} name="r1_POC_Name" />
                            <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r1_Phone" />
                            <JVInput placeholder="Email" column={4} control={control} name="r1_Email" error={errors.r1_Email?.message} />
                        </div>
                        {refCount > 1 && <div className="p-fluid formgrid grid">
                            <JVInput placeholder="Company Name" column={4} control={control} name="r2_Company_Name" />
                            <JVInput placeholder="POC Name" column={4} control={control} name="r2_POC_Name" />
                            <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r2_Phone" />
                            <JVInput placeholder="Email" column={4} control={control} name="r2_Email" error={errors.r2_Email?.message} />
                        </div>}
                        {refCount > 2 && <div className="p-fluid formgrid grid">
                            <JVInput placeholder="Company Name" column={4} control={control} name="r3_Company_Name" />
                            <JVInput placeholder="POC Name" column={4} control={control} name="r3_POC_Name" />
                            <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r3_Phone" />
                            <JVInput placeholder="Email" column={4} control={control} name="r3_Email" error={errors.r3_Email?.message} />
                        </div>}
                        {refCount !== 3 && <Button icon="pi pi-plus" type="button" className="p-button-rounded p-button-success" aria-label="Add More"
                            onClick={() => setRefCount(refCount + 1)} />}
                    </AccordionTab>
                    <AccordionTab header="Additional Info:">
                        <div className="p-fluid formgrid grid">
                            <div className="col-12 md:col-12 md:col-6">
                                <JVSunEditor value={additionInfo} handleChange={setAdditionInfo} />
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
                <div className="field col-12 md:col-4">
                    <FileUpload chooseLabel="Choose Resume" mode="basic" name="resume" accept=".docx" auto customUpload uploadHandler={resumeUpload} />
                </div>
            </form>
            <SubmissionsTable data={subTable.data} hideDialog={hideSubTable} open={subTable.open} toast={props.toast} />
            <EmployerDetails onEmployerSelect={handleEmployerSelect} consultant_ID={employerDetails.consultant_ID} data={employerDetails.data} hideDialog={hideSubTable} open={employerDetails.open} toast={props.toast} />
        </Dialog >
    );
}
